import { render, staticRenderFns } from "./_upay.vue?vue&type=template&id=5a13bd1e&lang=pug&"
import script from "./_upay.vue?vue&type=script&lang=js&"
export * from "./_upay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports